var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Component from "../lib/component";
import { ComponentInstances } from "../lib/page-component";
import html from "./tree.html";
import "./tree.scss";
import * as ajax from '../app-lib/ajax_proxy';
// import { TreeNode, MyComponent as TreeComponent } from "../components/tree";
var RootId = "xx"; //"00000000-0000-0000-0000-000000000000")
var TreeNode = /** @class */ (function () {
    function TreeNode(id, name, pid, type, isOpen, isSelected, isChecked) {
        if (isOpen === void 0) { isOpen = false; }
        if (isSelected === void 0) { isSelected = false; }
        if (isChecked === void 0) { isChecked = false; }
        this.id = id;
        this.name = name;
        this.pid = pid;
        this.type = type;
        this.isOpen = isOpen;
        this.isSelected = isSelected;
        this.isChecked = isChecked;
        this.children = [];
    }
    TreeNode.clone = function (obj, treeId) {
        // let okSelectChilen = true;
        ko.postbox.subscribe("isSelectChilen", function (r) {
            console.log(r);
            console.log('---------tree');
            ComponentInstances[treeId].okSelectChilen = r;
        });
        var newNode = new TreeNode(obj.id, obj.name, obj.pid);
        // 
        Object.getOwnPropertyNames(obj).forEach(function (p) {
            newNode[p] = obj[p];
        });
        ko.track(newNode);
        ko.getObservable(newNode, "isChecked").subscribe(function (n) {
            if (newNode.id == '0') {
                newNode.isChecked = true;
                // window.popBox.show('跟节点不可操作！');
            }
            if (n) {
                if (newNode.id == '0') {
                    return window.popBox.show('根节点无法操作');
                }
                newNode.isChecked = true;
                console.log(newNode);
                var depa = ComponentInstances[treeId].rData;
                var nid = newNode.id;
                for (var key in depa) {
                    if (depa[key].path) {
                        if (depa[key].id == nid) {
                            // console.log(depa[key].id)
                            // mynode.push()
                            depa[key].isChecked = true;
                        }
                    }
                }
                if (ComponentInstances[treeId].okSelectChilen) {
                    // var mynode=[];
                    var nid_1 = newNode.id;
                    for (var key in depa) {
                        if (depa[key].path) {
                            if (Number(depa[key].path.indexOf(nid_1)) >= 0) {
                                // console.log(depa[key].id)
                                // mynode.push()
                                depa[key].isChecked = true;
                            }
                        }
                    }
                    //勾选父级全部选中子集
                    var getChildChecked_1 = function (newNode, i) {
                        newNode.isChecked = true;
                        newNode.children.forEach(function (p) { return (getChildChecked_1(p, i + 1)); });
                    };
                    // let getChildChecked = (mynode: any, i: number) => {
                    //     mynode.isChecked = true;
                    //     mynode.children.forEach(p => (getChildChecked(p, i + 1)))
                    // }
                    var root = newNode.children; //newNode.children;
                    root.forEach(function (p) { return (getChildChecked_1(p, 0)); });
                    //选中一个子集 递归勾选父级
                    // let p = newNode.parent
                    // while (p != null) {
                    //     p.isChecked = true
                    //     p = p.parent
                    // }
                    // console.log(n);
                    // if( newNode.parent){
                    //     newNode.parent.isChecked=true;
                    // }
                    //全部勾选子集 选中当前父级
                    // let par=this.parent;
                    // let isAllCheck=(node:TreeNode)=>{
                    //     let flag=false;
                    //     if(node&&node.children){
                    //         node.children.forEach(p=>{
                    //             //  console.log(p);
                    //               if(p.isChecked==true){
                    //                   flag=true;
                    //               }else{
                    //                   flag=false;
                    //               }
                    //           });
                    //         return flag; 
                    //     }
                    // }
                    // if(par){
                    //     par.isChecked=isAllCheck(par);
                    // }
                }
            }
            else {
                if (newNode.id == '0') {
                    return window.popBox.show('根节点无法操作');
                }
                // 取消父级 全部取消子集
                var deletChildChecked_1 = function (node, i) {
                    node.isChecked = false;
                    node.children.forEach(function (p) { return (deletChildChecked_1(p, i + 1)); });
                };
                var root = newNode.children;
                root.forEach(function (p) { return (deletChildChecked_1(p, 0)); });
                var depa = ComponentInstances[treeId].rData;
                // var younode=[];
                var vid = newNode.id;
                for (var key in depa) {
                    if (depa[key].path) {
                        if (Number(depa[key].path.indexOf(vid)) >= 0) {
                            // console.log(depa[key].id)
                            // mynode.push()
                            depa[key].isChecked = false;
                        }
                    }
                }
            }
        });
        return newNode;
    };
    TreeNode.prototype.addChild = function (id, name) {
        if (name == null || name == '' || name == undefined) {
            // window.popBox.show('名称不能为空');
            return;
        }
        else if (name.length < 10) {
            this.isOpen = true;
            var newNode = new TreeNode(id, name, this.id);
            newNode.parent = this;
            this.children.push(newNode);
        }
    };
    TreeNode.prototype.deleteNode = function () {
        if (!this.parent)
            return;
        this.parent.children.remove(this);
    };
    TreeNode.prototype.edit = function (newName) {
        if (newName == null || newName == "" || newName == undefined) {
            return;
        }
        else if (newName.length < 10) {
            this.name = newName;
        }
    };
    return TreeNode;
}());
export { TreeNode };
var defaultOptions = {
    url: undefined,
    isCanEdit: false,
    isShowCheckbox: false,
    onSelect: function () { },
    onDelete: function () { },
    onEdit: function () { },
    onAdd: function () { },
    data: undefined,
    rootId: RootId,
};
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        var _this = _super.call(this, "tree", html) || this;
        _this.data = [];
        _this.rData = [];
        ko.track(_this, ["data"]);
        return _this;
    }
    MyComponent.prototype.init = function () {
        this.options = __assign({ selectedNode: ko.observable(), checkedNode: ko.observableArray() }, defaultOptions, this.options);
        this.parseOptions();
    };
    MyComponent.prototype.getCheckedNode = function () {
        var tmp = this.rData.filter(function (p) { return p.isChecked; });
        return tmp;
        var ds = [];
        var getChildChecked = function (node, i) {
            var tmp = node.children.filter(function (p) { return p.isChecked; });
            ds.push.apply(ds, tmp);
            node.children.forEach(function (p) { return (getChildChecked(p, i + 1)); });
        };
        var root = this.data.filter(function (p) { return p.isChecked; });
        ds.push.apply(ds, root);
        this.data.forEach(function (p) { return (getChildChecked(p, 0)); });
        return ds;
    };
    MyComponent.prototype.selectIt = function (data) {
        var last = this.options.selectedNode();
        if (last)
            last.isSelected = false;
        this.options.selectedNode(data);
        if (this.options.onSelect)
            this.options.onSelect(data);
        data.isSelected = true;
    };
    MyComponent.prototype.onClick = function (it, e) {
        var _this = this;
        var target = e.target;
        var data = ko.dataFor(target);
        e.stopPropagation();
        if (target.tagName === "INPUT") {
            return true;
        }
        if (target.tagName === "LABEL" || target.tagName === "SPAN") {
            this.selectIt(data);
        }
        if (target.tagName === "BUTTON" && target.textContent.indexOf("add") > -1) {
            var newNode_1 = TreeNode.clone({ pid: data.id }, this.options['id']);
            this.selectIt(newNode_1);
            window.popBox.show(this.container.querySelector("#popNode"), { isConfirmModal: true, title: '新增岗位' }).then(function () {
                data.addChild(newNode_1.id, newNode_1.name);
                _this.options.onAdd(newNode_1);
                _this.selectIt(data);
            }, function () { return _this.selectIt(data); });
        }
        if (target.tagName === "BUTTON" && target.textContent.indexOf("edit") > -1) {
            this.selectIt(data);
            window.popBox.show(this.container.querySelector("#popNode"), { isConfirmModal: true, title: '编辑岗位' }).then(function () { return _this.options.onEdit(data); }).catch();
            // this.options.onDelete(data)
        }
        if (target.tagName === "BUTTON" && target.textContent.indexOf("delete") > -1) {
            this.selectIt(data);
            window.popBox.show("是否确认删除？", { isConfirmModal: true, title: '提示' }).then(function () {
                data.deleteNode();
                _this.options.onDelete(data);
            }).catch(function () { });
        }
    };
    MyComponent.prototype.parse = function (ds) {
        var _this = this;
        if (!ds)
            return [];
        if (ds["data"])
            ds = ds["data"];
        if (ds.length && ds[0].children)
            return ds;
        if (ds["list"])
            ds = ds["list"];
        this.rData = ds;
        if (this.rData[0].id == '0') {
            this.rData[0].isChecked = true;
        }
        var rootModes = this.getChildren(this.options.rootId);
        rootModes.forEach(function (n) { return (n.isOpen = true, _this.setChildren(n, 0, 1)); }); //(this.options.isShowCheckbox)?100:1))
        this.data = rootModes;
        return rootModes;
    };
    MyComponent.prototype.onExpand = function (node) {
        if (node.isLazyLoad) {
            node.children = [];
            this.setChildren(node, 0, 1);
            node.isLazyLoad = false;
        }
        // if (node.children.length && node.children[0].isLazyLoad) {
        //     node.children.forEach(p => (p.isLazyLoad = false, this.setChildren(p, 0, 1)))
        // }
        return true;
    };
    MyComponent.prototype.getChildren = function (pid) {
        var _this = this;
        return this.rData.filter(function (p) { return p.pid == pid; }) //.slice(0, 2)
            .map(function (p) {
            return TreeNode.clone(p, _this.options["id"]);
        });
    };
    MyComponent.prototype.step = function (node, ds, from, span, deep, max) {
        var _this = this;
        var slice = ds.slice(from, from + span);
        slice.forEach(function (p) { return (p.parent = node, _this.setChildren(p, deep + 1, max)); });
        //deep == 0 ? node.children = slice : 
        node.children.push.apply(node.children, slice);
        if (from < ds.length)
            requestAnimationFrame(this.step.bind(this, node, ds, from + span, span, deep, max));
    };
    MyComponent.prototype.setChildren = function (node, i, max) {
        //console.log(new Array(i).join("\t") + "s:" + i)
        var _this = this;
        if (max === void 0) { max = 100; }
        if (i >= max) {
            node.children = [];
            node.isLazyLoad = true;
        }
        if (i == max) {
            node.children = this.rData.filter(function (p) { return p.pid == node.id; }).slice(0, 1).map(function (p) {
                return TreeNode.clone(p, _this.options["id"]);
            });
            return;
        }
        var tmp = this.getChildren(node.id);
        if (tmp.length == 0)
            return;
        requestAnimationFrame(this.step.bind(this, node, tmp, 0, 100, i, max));
        //console.log(new Array(i).join("\t") + "e:" + i)
    };
    MyComponent.prototype.parseOptions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var parseData, parseUrl;
            var _this = this;
            return __generator(this, function (_a) {
                parseData = function (n) { return _this.parse(n); } // this.data = 
                ;
                this.subscribeAndExec(this.options.data, parseData);
                parseUrl = function (n) { n ? (ajax.get(n).then(function (ds) { return _this.parse(ds); })) : (_this.data = []); };
                this.subscribeAndExec(this.options.url, parseUrl);
                return [2 /*return*/];
            });
        });
    };
    MyComponent.prototype.subscribeAndExec = function (observable, action) {
        if (observable) {
            if (ko.isObservable(observable)) {
                observable.subscribe(function (n) { return action(n); });
                observable = observable();
            }
            action(observable);
        }
    };
    return MyComponent;
}(Component));
export { MyComponent };
export default new MyComponent();
